/* eslint-disable max-len */
import { Alert } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { AlertProps, BaseAlertProps } from './types';

const AlertMessage = (props: BaseAlertProps) => {
    const {
        id,
        testId,
        children,
        canClose,
        onClose,
        className = '', // default props
        variant,
        role,
        ariaLive,
    } = props;

    const [show, setShow] = useState<boolean>(true);

    const closeAlert = () => {
        if (onClose) {
            onClose();
        }

        setShow(false);
    };

    useEffect(() => {
        setShow(true);
    }, [children]);

    return (
        <Alert
            id={id}
            data-testid={testId}
            role={role || 'status'}
            className={`d-flex ${className}`}
            dismissible={canClose}
            onClose={closeAlert}
            show={show}
            variant={variant}
            aria-live={ariaLive || 'polite'}
            tabIndex={-1}
        >
            {children}
        </Alert>
    );
};

// AlertMessage.defaultProps = {
//     className: '',
// };

export const AlertSuccess = (props: AlertProps) => <AlertMessage variant='success' {...props} />;

export const AlertInfo = (props: AlertProps) => <AlertMessage variant='info' {...props} />;

export const AlertWarning = (props: AlertProps) => <AlertMessage variant='warning' {...props} />;

export const AlertError = (props: AlertProps) => <AlertMessage variant='danger' {...props} />;
